import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchLeagues } from '../lib/api';
import type { League } from '../lib/types';
import { Skeleton } from '../components/ui/Skeleton';
import usePageTitle from '../hooks/usePageTitle';

export default function LeaguesPage() {
  usePageTitle('Leagues');

  const [leagues, setLeagues] = useState<League[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLeagues()
      .then(setLeagues)
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <h1 className="text-2xl font-bold text-slate-100 mb-8">Leagues</h1>

      {loading ? (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {Array.from({ length: 8 }).map((_, i) => (
            <div key={i} className="card p-6 flex flex-col items-center gap-4">
              <Skeleton className="w-16 h-16 rounded-xl" />
              <div className="space-y-2 text-center">
                <Skeleton className="h-4 w-28 mx-auto" />
                <Skeleton className="h-3 w-16 mx-auto" />
              </div>
            </div>
          ))}
        </div>
      ) : leagues.length === 0 ? (
        <p className="text-slate-400 text-center py-12">No leagues found.</p>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {leagues.map((league) => (
            <Link
              key={league.id}
              to={`/league/${league.slug}`}
              className="card p-6 flex flex-col items-center gap-4
                         hover:bg-slate-700/40 transition-colors group"
            >
              {league.logo ? (
                <img
                  src={league.logo}
                  alt={league.name}
                  className="w-16 h-16 object-contain"
                />
              ) : (
                <div className="w-16 h-16 rounded-xl bg-slate-700 flex items-center justify-center text-slate-400 text-2xl font-bold">
                  {league.name.charAt(0)}
                </div>
              )}
              <div className="text-center">
                <h3 className="text-slate-100 font-semibold group-hover:text-emerald-400 transition-colors">
                  {league.name}
                </h3>
                {league.country && (
                  <p className="text-sm text-slate-500 mt-0.5">{league.country}</p>
                )}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
